var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.videoContent},[_c('iframe',{class:['wistia_embed', _vm.$style.video],attrs:{"allowfullscreen":"true","allowtransparency":"true","frameborder":"0","name":"wistia_embed","src":_vm.videoSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }